var bindsToShared = { vm: '=' };
var ReportingSharedController = (function () {
    function ReportingSharedController() {
        this.visibleShared = false;
    }
    ReportingSharedController.prototype.toggleShared = function () {
        if (this.visibleShared) {
            this.visibleShared = false;
        }
        else {
            this.visibleShared = true;
        }
    };
    return ReportingSharedController;
}());
var ReportingSharedComponent = (function () {
    function ReportingSharedComponent() {
        this.bindings = bindsToShared;
        this.templateUrl = 'report.shared.html';
        this.controller = ReportingSharedController;
    }
    return ReportingSharedComponent;
}());
angular
    .module('application')
    .config(function ($mdIconProvider) {
    $mdIconProvider
        .icon('clearAll', '/public/icons/ic_clear_all_black_18px.svg');
})
    .component('reportShared', new ReportingSharedComponent());

//# sourceMappingURL=reporting.shared.component.js.map
